<form [formGroup]="formGroup" *ngIf="mode !== itemMode.View" class="bg-white p-3 border-radius" [style.width]="'35vw'">
  <div>
    <div nz-row [nzGutter]="[16, 16]">
      <div nz-col nzSpan="24">
        <app-control formControlName="activated_date" [max]="curentDate"
          [controlConfig]="{title: 'doc.date', type: 'date', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="card_no" [controlConfig]="{title: 'card.code', type: 'text-number', required: true, max: 14}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="user_type" [options]="listUserType"
          [controlConfig]="{title: 'service-card.user_type', type: 'dropdown', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="owner" [options]="listOwnerByUser"
          (getMoreData)="isOwner ? getMoreDataOwner($event) : getMoreDataButler($event)"
          (dropdownSearch)="isOwner ? filterDataOwner($event) : filterDataButler($event)"
          [controlConfig]="{title: 'service-card.owner', type: 'dropdownServer', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="apartment_ids" [options]="listApartment" [customErrorText]="errorApartment"
          [controlConfig]="{title: 'apartment.label', type: 'multi-select', required: true}"></app-control>
      </div>
      <div nz-col nzSpan="24" class="note">
        <app-control formControlName="note" [controlConfig]="{title: 'note', type: 'textarea'}"></app-control>
      </div>
      <div nz-col nzSpan="24">
        <app-control formControlName="status" [options]="listServiceCardStatus"
          [controlConfig]="{title: 'status.title', type: 'status', required: true}"></app-control>
      </div>
    </div>
  </div>
</form>

<div *ngIf="mode == itemMode.View" [style.width]="'55vw'">
  <div class="bg-white p-3 border-radius">
    <h4>{{ 'service-card.info' | translate }}</h4>
    <div nz-row [nzGutter]="[16,16]">
      <div nz-col nzSpan="6">
        <span>{{ 'doc.date' | translate }}</span>
        <div>{{ detailCard.activated_date | date: 'dd/MM/yyyy' }}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'card.code' | translate }}</span>
        <div>{{ detailCard.card_no }}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'service-card.owner' | translate }}</span>
        <div>{{ detailCard.card_owner }}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'status.title' | translate }}</span>
        <div>
          <span class="status-box"
            [ngClass]="detailCard.status == status.Active ? 'active' : detailCard.status == status.Pending ? 'inactive' : 'canceled'">
            {{ (detailCard.status == status.Active ? 'status.in_use' : detailCard.status == status.Pending ? 'status.pending' : 'status.blocked') | translate }}
          </span>
        </div>
      </div>
      <div nz-col nzSpan="24">
        <span>{{ 'apartment.label' | translate }}</span>
        <div>{{ detailCard.apartment_codes }}</div>
      </div>
      <div nz-col nzSpan="24">
        <span>{{ 'note' | translate }}</span>
        <div>{{ detailCard.note || '-' }}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'service-card.deposit_balance' | translate }}</span>
        <div>{{ detailCard.total_cash | number}}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'service-card.converted_balance' | translate }}</span>
        <div>{{ detailCard.total_cash_voucher | number}}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'service-card.top-up_service_balance' | translate }}</span>
        <div>{{ detailCard.total_service | number}}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'service-card.conversion_service_balance' | translate }}</span>
        <div>{{ detailCard.total_service_voucher | number}}</div>
      </div>
    </div>
  </div>
  <div class="bg-white p-3 mt-4 border-radius" *ngIf="!!detailCard?.balances?.length">
    <h4 class="mb-2">{{ 'service-card.package-detail' | translate }}</h4>
    <div>
      <nz-table #packageTable [nzData]="detailCard.balances || []" nzBordered [nzShowPagination]="false" [nzScroll]="{ y: '240px' }" >
        <thead>
          <tr>
            <th nzWidth="60px">{{ 'index' | translate }}</th>
            <th nzWidth="140px">{{ 'apartment-type.label' | translate }}</th>
            <th>{{ 'service-package.name' | translate }}</th>
            <th>{{ 'funds.title' | translate }}</th>
            <th nzWidth="140px">{{ 'payment.available-balance' | translate }}</th>
            <th nzWidth="140px">{{ 'payment.date-expire' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of packageTable.data; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.apartment_type_name }}</td>
            <td>{{ item.code + ' - ' + item.name }}</td>
            <td>{{ 'funds.' + item.type | translate }}</td>
            <td>{{ item.balance | number }}</td>
            <td>{{ (item.expired_date | date: 'dd/MM/yyyy') || '-' }}</td>
          </tr>
          <tr *ngIf="!packageTable.data.length">
            <td colspan="5" class="text-center">-</td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
  <div class="bg-white p-3 mt-4 border-radius">
    <h4 class="mb-2">{{ 'service-card.info_update' | translate }}</h4>
    <div nz-row [nzGutter]="[16,16]">
      <div nz-col nzSpan="6">
        <span>{{ 'created' | translate }}</span>
        <div>{{ (detailCard.date_created | date: 'dd/MM/yyyy') || '-' }}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'creator' | translate }}</span>
        <div>{{ detailCard.created_by || '-' }}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'updated' | translate }}</span>
        <div>{{ (detailCard.date_updated | date: 'dd/MM/yyyy') || '-' }}</div>
      </div>
      <div nz-col nzSpan="6">
        <span>{{ 'updater' | translate }}</span>
        <div>{{ detailCard.updated_by || '-' }}</div>
      </div>
    </div>
  </div>
</div>

<div *nzModalTitle class="title-modal">{{mode |translate}} {{'service-card.label' | translate}}</div>
<div *nzModalFooter>
  <button nz-button class="btn-cancel-modal" (click)="destroyModal()">{{'close' | translate}}</button>
  <ng-container *ngIf="mode == itemMode.View && (data.status !== status.Block || data.deleted === DeleteStatus.YES)">
    <button nz-button nzType="primary" (click)="edit()">{{'edit' | translate}}</button>
  </ng-container>
  <ng-container *ngIf="mode !== itemMode.View">
    <button nz-button nzType="primary" (click)="onSave()">{{'save' | translate}}</button>
  </ng-container>
</div>